import React from "react";
import { AudioItem } from "../components/audio-item/AudioItem";

export function Greetings() {
  return (
    <div className="page">
      <AudioItem
        filePath={"./audio/greetings/ngudda_kamak.mp3"}
        kwText={"Ngudda kamak?"}
        enText={"How are you? / Are you well?"}
      />
      <AudioItem
        filePath={"./audio/greetings/yoh_ngaye_kamak.mp3"}
        kwText={"Yoh, ngaye kamak"}
        enText={"Yes, I'm well"}
      />
      <AudioItem
        filePath={"./audio/greetings/kamak-rowk.mp3"}
        kwText={"Kamak rowk"}
        enText={"All good!"}
      />
      <AudioItem
        filePath={
          "./audio/greetings/nangale-yingeyyo-AM-Whats-your-name-male.mp3"
        }
        kwText={"Nangale yingeyyo?"}
        enText={"What's your name? (to a man)"}
      />
      <AudioItem
        filePath={"./audio/greetings/ngalngale-yingeyyo.mp3"}
        kwText={"Ngalngale yingeyyo?"}
        enText={"What's your name? (to a woman)"}
      />
      <AudioItem
        filePath={"./audio/greetings/ngaye_ngangeyyo_Jill_My-name-is-Jill.mp3"}
        kwText={"Ngaye ngangeyyo Jill"}
        enText={"My name is Jill"}
      />
    </div>
  );
}
